export const AppConfig = {
  LANGUAGES: ['pl'], // Language order matters in fallbacks
  TRANSLATIONS: ['pl'], // Available .json translation files, order matters in fallbacks
  DEFAULT_LANG: 'pl',
};
